import styles from "./styles.module.css";

export function Loading() {
  return (
    <div className={styles.loading_container}>
      <div className={styles.loading_spinne}></div>
    </div>
  );
}
